import DataAccess from './constants';
import API from './API';
const path = '/api/Transactions'

const { PaymentMethodType } = window['runConfig'];


export const posttransaction = (postdata) => {
    let api = new API(DataAccess.middlewareUrl, DataAccess.userName, DataAccess.password, DataAccess.middlewareUserName, DataAccess.middlewarePassword);
    let token = postdata.token ? postdata.token.token : '';
    let paymentamount = postdata.primaryAmount; // postdata.transaction[0].Payments[0] !== undefined ? postdata.transaction[0].Payments[0].PaymentAmount : 0;
    let email = postdata.email;
    let customerName = postdata.customerName;
    let recaptchav3token = postdata.recaptchav3token;

    return api.postData(path + "?token=" + token + "&amount=" + (PaymentMethodType === "Spreedly" ? parseInt((paymentamount * 100).toFixed()) : parseFloat(paymentamount).toFixed(2)) + "&alternateamount=" + (PaymentMethodType === "Spreedly" ? parseInt((postdata.alternateamount * 100).toFixed()) : parseFloat(postdata.alternateamount).toFixed(2)) + "&email=" + email + "&customerName=" + customerName + "&recaptchav3token=" + recaptchav3token, postdata.transaction, true);
}